<template>
  <div class="">
    <v-container>
      <h2 class="text-lg-center text-md-center text-sm-center earth-color">
        MEMBERSHIP PAYMENT
      </h2>
    </v-container>
    <v-layout row wrap>
      <v-flex xs12 lg4>
        <v-card flat>
          <h2 class="text-lg-center text-md-center text-sm-center earth-color">
            MEMBERSHIP DETAILS
          </h2>
          <v-container fluid>
            <div class="row">
              <div class="span3" style="float: none; margin: 0 auto">
                <h3 class="earth-color">Membership Type:</h3>
                <br />
                {{ singleMember.level }} ({{ singleMember.residence }} -
                {{ singleMember.setting }})
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="span3" style="float: none; margin: 0 auto">
                <h3 class="earth-color">Admits:</h3>
                <br />
                {{ singleMember.num_of_persons }} adult(s)
                <br />
                {{ singleMember.num_of_children }} children
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="span3" style="float: none; margin: 0 auto">
                <h3 class="earth-color">
                  TOTAL: {{ localCurrency }} {{ singleMember.amount }}
                </h3>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 lg8 md12>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex
              xs12
              sm6
              md6
              lg4
              class="pa-2"
              v-if="$paymentOptions[1].active === true"
            >
              <label class="payment-card-label">
                <v-card
                  flat
                  class="clickable-card fill-height"
                  :class="{ 'selected-card': payment_mode === 'Mpesa' }"
                >
                  <img
                    src="https://marketplace.datingpro.com/image/data/payment%20systems/m-pesa-integration.png"
                    width="100%"
                    height="auto"
                    class="center-block payment-card-img"
                  />
                  <v-card-title primary-title>
                    <div>
                      <h1 class="earth-color">MPESA</h1>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <input
                      v-model="payment_mode"
                      type="radio"
                      value="Mpesa"
                      class="form-control"
                    />
                  </v-card-actions>
                </v-card>
              </label>
            </v-flex>

            <v-flex
              xs12
              sm6
              md6
              lg4
              class="pa-2"
              v-if="$paymentOptions[0].active === true"
            >
              <label class="payment-card-label">
                <v-card
                  flat
                  class="clickable-card fill-height"
                  :class="{ 'selected-card': payment_mode === 'Card' }"
                >
                  <img
                    src="https://www.freeiconspng.com/uploads/credit-cards-icon-25.png"
                    width="100%"
                    height="auto"
                    alt=""
                    class="payment-card-img"
                  />
                  <v-card-title primary-title>
                    <div>
                      <h1 class="earth-color">IVERI</h1>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <input
                      v-model="payment_mode"
                      type="radio"
                      value="Card"
                      class="form-control"
                    />
                  </v-card-actions>
                </v-card>
              </label>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <v-card flat v-if="payment_mode === 'Card'">
      <v-container>
        <div class="col-md-12">
          <div class="">
            <div class="">
              <form
                id="myform"
                name="myform"
                METHOD="POST"
                ACTION="https://portal.host.iveri.com/Lite/Authorise.aspx"
              >
                <input
                  id="Lite_Merchant_Applicationid"
                  name="Lite_Merchant_Applicationid"
                  type="hidden"
                  :value="kes_live_id"
                  readonly="true"
                />
                <input
                  id="Lite_Order_Amount"
                  name="Lite_Order_Amount"
                  type="hidden"
                  :value="paymentUSDPrice"
                  readonly="true"
                />
                <input
                  type="hidden"
                  name="Lite_Website_Successful_url"
                  :value="iveri_catcher_url + 'member-payment'"
                />
                <input
                  type="hidden"
                  name="Lite_Website_Fail_url"
                  :value="
                    iveri_url + '/membership-payment/' + singleMember.public_id
                  "
                />
                <input
                  type="hidden"
                  name="Lite_Website_TryLater_url"
                  :value="
                    iveri_url + '/membership-payment/' + singleMember.public_id
                  "
                />
                <input
                  type="hidden"
                  name="Lite_Website_Error_url"
                  :value="
                    iveri_url + '/membership-payment/' + singleMember.public_id
                  "
                />
                <input
                  id="Lite_Currency_AlphaCode"
                  name="Lite_Currency_AlphaCode"
                  type="hidden"
                  value="KES"
                  readonly="true"
                />
                <input
                  id="Lite_Order_LineItems_Product_1"
                  name="Lite_Order_LineItems_Product_1"
                  type="hidden"
                  value="Membership Total"
                  readonly="true"
                />
                <input
                  id="Lite_Order_LineItems_Quantity_1"
                  name="Lite_Order_LineItems_Quantity_1"
                  type="hidden"
                  value="1"
                  readonly="true"
                />
                <input
                  id="Lite_Order_LineItems_Amount_1"
                  name="Lite_Order_LineItems_Amount_1"
                  type="hidden"
                  :value="paymentUSDPrice"
                  readonly="true"
                />
                <input
                  id="Lite_ConsumerOrderID_PreFix"
                  name="Lite_ConsumerOrderID_PreFix"
                  type="hidden"
                  value="DML"
                  readonly="true"
                />
                <input
                  id="Ecom_BillTo_Online_Email"
                  name="Ecom_BillTo_Online_Email"
                  type="hidden"
                  :value="singleMember.email"
                />
                <input
                  id="Ecom_Payment_Card_Protocols"
                  name="Ecom_Payment_Card_Protocols"
                  type="hidden"
                  value="iVeri"
                  readonly="true"
                />
                <input
                  id="MemberId"
                  name="MemberId"
                  type="hidden"
                  :value="singleMember.public_id"
                />
                <input
                  id="Ecom_TransactionComplete"
                  name="Ecom_TransactionComplete"
                  type="hidden"
                  value=""
                  readonly="true"
                />
                <font color="red"
                  ><p class="warningtext" id="warning" name="warning">
                    &nbsp;
                  </p></font
                >
                <li>
                  <v-text-field
                    id="txtEmail"
                    name="txtEmail"
                    v-model="singleMember.email"
                    :rules="requiredRules"
                    label="Email"
                    required
                  ></v-text-field>
                </li>
                <li>
                  <input
                    type="text"
                    hidden="hidden"
                    id="Amount"
                    name="Amount"
                    class="text"
                    :value="paymentUSDPrice"
                  /><a href="#" class="icon user" tabindex="-1"></a>
                </li>

                <br />
                <div class="submit">
                  <v-btn
                    :depressed="true"
                    type="submit"
                    id="btnsubmit"
                    class="btn primary btn-block"
                    name="btnsubmit"
                    color="primary"
                    >Proceed to Card Payment</v-btn
                  >
                  <br />
                  <br />
                  <h3 class="text-center earth">
                    PLEASE RE-CONFIRM YOUR EMAIL ADDRESS TO PROCEED WITH PAYMENT
                  </h3>
                  <div class="clear"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-container>
    </v-card>
    <v-card flat v-if="payment_mode === 'Mpesa'">
      <v-card flat>
        <v-container fluid>
          <div class="earth text-center">
            KINDLY NOTE THAT PAYMENTS ABOVE KES 250,000 CANNOT BE PROCESSED
          </div>
          <br />
          <br />
          <v-layout>
            <v-flex lg3 md3></v-flex>
            <v-flex lg12 md12 sm12 xs12>
              <v-text-field
                label="Safaricom Phone Number"
                v-model="phone_number"
                required
                type="tel"
                placeholder="254..."
              ></v-text-field>
              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12>
                  <v-container>
                    <v-btn
                      :depressed="true"
                      color="primary"
                      block
                      @click="requestMpesa()"
                      >Request Payment</v-btn
                    >
                  </v-container>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                  <v-container>
                    <v-btn
                      :depressed="true"
                      color="warning"
                      block
                      @click="confirmPayment()"
                      v-if="confirm === true"
                      >Confirm Payment</v-btn
                    >
                  </v-container>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-card>
    {{ paymentCheck }}
  </div>
</template>

<script>
import MembershipCart from "../Repeated/MembershipCart";
export default {
  name: "new-membership-payment",
  components: {
    MembershipCart,
  },
  data() {
    return {
      confirm: false,
      payment_mode: "",
      memberId: this.$route.params.member_id,
      phone_number: "254",
    };
  },
  beforeCreate() {
    this.$store.dispatch("get_payment_platforms");
  },
  created() {
    this.$store.dispatch("get_member", this.$route.params.member_id);
    this.$store.dispatch("get_jenga_auth");
  },
  computed: {
    paymentCheck() {
      if (
        this.singleMember.payment_status === true ||
        this.singleMember.payment_status === "true"
      ) {
        this.redirectToSuccessPage();
      }
      return null;
    },
    paymentKESPrice: function () {
      return Number(this.singleMember.amount);
    },
    paymentUSDPrice: function () {
      var total = 0;
      total = this.singleMember.amount * 100;
      return total;
    },
  },
  methods: {
    redirectToSuccessPage() {
      this.$router.push({
        name: "SuccessMembership",
      });
    },
    confirmPayment() {
      this.$store.dispatch("get_member", this.$route.params.member_id);
    },
    requestMpesa() {
      this.confirm = true;
      var data = {
        reference_number: this.$route.params.member_id,
        phone_number: this.phone_number,
      };
      this.$store.dispatch("member_request_mpesa", data);
    },
  },
};
</script>

<style scoped>
li {
  text-decoration: none;
  list-style: none;
}

/* --- Responsive payment card fixes --- */

.payment-card-label {
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.clickable-card {
  transition: all 0.2s ease;
  border: 2px solid transparent;
  border-radius: 8px;
  height: 100%;
}

.payment-card-label:hover .clickable-card {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.selected-card {
  border-color: #587e27;
  box-shadow: 0 4px 12px rgba(88, 126, 39, 0.25);
}

.payment-card-img {
  display: block;
  max-height: 180px;
  object-fit: contain;
}

/* Tighten spacing on small screens */
@media (max-width: 600px) {
  .payment-card-img {
    max-height: 140px;
  }
}
</style>